/* eslint-disable import/prefer-default-export */
import { ref, watch } from '@vue/composition-api'
import moment from 'moment'
import {
  normalizePlannerDate,
  createPlannerCreateQuery,
  resolvePlannerDateQuery,
} from '@/views/orders/Planner/setup'

export const usePlannerNavigation = (route, router) => {
  const initialDate = resolvePlannerDateQuery(route.value.query.date) || normalizePlannerDate()
  const selectedDate = ref(initialDate)

  const updateRouteQuery = nextDate => {
    const currentDate = resolvePlannerDateQuery(route.value.query.date)
    if (currentDate === nextDate) {
      return Promise.resolve()
    }
    if (!router || typeof router.replace !== 'function') {
      return Promise.resolve()
    }
    return router.replace({
      query: { ...route.value.query, date: nextDate },
    }).catch(error => {
      if (error?.name !== 'NavigationDuplicated') {
        throw error
      }
    })
  }

  updateRouteQuery(initialDate)

  const syncSelectedDateFromRoute = value => {
    const nextDate = normalizePlannerDate(value)
    if (nextDate === selectedDate.value) {
      return
    }
    selectedDate.value = nextDate
  }

  watch(() => route.value.query.date, syncSelectedDateFromRoute)

  const handleSelectedDateChange = value => {
    const nextDate = normalizePlannerDate(value)
    if (nextDate === selectedDate.value) {
      return
    }
    selectedDate.value = nextDate
    updateRouteQuery(nextDate)
  }

  const goToOrderView = id => {
    if (!id || !router || typeof router.push !== 'function') {
      return
    }
    router.push({ name: 'order-view', params: { id: String(id) } })
  }

  const goToOrderEdit = id => {
    if (!router || typeof router.push !== 'function') {
      return
    }
    router.push({ name: 'order-edit', params: { id } })
  }

  const handleCellDoubleClicked = args => {
    const resourceId = String(args?.resourceObj?.id || args?.resource || '')
    const start = moment(args?.date || args?.start)
    if (!resourceId || !start.isValid()) {
      return
    }
    const query = createPlannerCreateQuery({ resourceId, start })
    router.push({ name: 'order-create', query })
  }

  return {
    selectedDate,
    handleSelectedDateChange,
    syncSelectedDateFromRoute,
    updateRouteQuery,
    handleCellDoubleClicked,
    goToOrderView,
    goToOrderEdit,
  }
}
